import React, { useEffect, useState } from 'react';
import { BunkeringEvent, BunkeringStatusEnum } from 'src/types/ViewModel/Bunkering/BunkeringEvent';
import { BunkeringRegListItemStyle } from '../Bunkering.styles';
import { prettifyDateTimeHHmm } from 'odfjell-date-time-utils/dateTimeFormatter';
import { BunkerRegistrationStatusIcon } from './status/BunkerRegistrationStatusIcon';
import { Bunkering } from 'src/types/ViewModel/Bunkering/Bunkering';
import { useBunkerContext } from 'src/context/BunkerContext';
import { getBunkeringForBunkeringEvent } from '../BunkeringUtils';

interface BunkerRegistrationListItemProps {
    bunkeringEvent: BunkeringEvent;
    selected: boolean;
    onSelectBunkeringEvent: (id: string) => void;
}

const BunkerRegistrationListItem: React.FC<BunkerRegistrationListItemProps> = ({ bunkeringEvent, selected, onSelectBunkeringEvent }) => {
    const { bunkerings } = useBunkerContext();
    const [bunkering, setBunkering] = useState<Bunkering>();

    useEffect(() => {
        if (bunkeringEvent && bunkerings && bunkerings.length > 0) {
            const selectedBunkering = getBunkeringForBunkeringEvent(bunkeringEvent, bunkerings);
            setBunkering(selectedBunkering);
        }
    }, [bunkeringEvent, bunkerings]);

    return (
        <BunkeringRegListItemStyle key={bunkeringEvent.eventID} selected={selected} onClick={() => onSelectBunkeringEvent(bunkeringEvent.id)}>
            <td>{bunkering?.bunkeringReference ?? bunkeringEvent.bunkeringReference}</td>
            <td>
                {BunkerRegistrationStatusIcon(bunkering?.currentStatus?.status ?? BunkeringStatusEnum.Unknown, bunkering?.bunkeringStatuses ?? [])}
            </td>
            <td>{prettifyDateTimeHHmm(bunkeringEvent.bunkeringDateTimeLocal)}</td>
            <td>{bunkeringEvent.voyageNumber}</td>
        </BunkeringRegListItemStyle>
    );
};

export default BunkerRegistrationListItem;
